export default function () {
    return {

        doLogout() {
            this.$session.destroy()
            this.$router.push('/')
        },

        // Public url
        publicUrl: process.env.BASE_URL,

        // Base del API. En desarrollo se puede apuntar a otro host definiendo
        // VUE_APP_API_BASE en un archivo .env.development.local (no versionado),
        // por ejemplo para usar el API arrancado con `dotnet run` en el puerto 5001.
        // Sin esa variable se mantiene el comportamiento de siempre.
        apiBase: process.env.NODE_ENV === 'production'
            ? '//voluntariadotransparencia.com/segel-api/'
            : (process.env.VUE_APP_API_BASE || 'https://localhost:44398/'),

        get apiUrl() { return this.apiBase + 'api/'; },
        get filesUrl() { return this.apiBase; },
        get notifyHubUrl() { return this.apiBase + 'notify-hub/'; },
        get commonBaseUrl() { return this.apiBase; },

        publicResource(path) {
            return this.publicUrl + path;
        },

        apiRoute(controller, action) {
            return this.apiUrl + controller + '/' + action;
        },

        apiResource(path) {
            if (!path) return path;
            if (/^https?:\/\//i.test(path)) return path;
            return this.filesUrl + path;
        },

        commonUrlResource(path) {
            return this.commonBaseUrl + path;
        },
    }
}
